import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Box,
  InputLabel,
  Modal,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Divider,
  Collapse,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FolderIcon from "@mui/icons-material/Folder";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { createClaim, updateBranchClaim } from "../../actions/claim";
import * as React from "react";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    fontWeight: "bold",
    fontSize: "12px",
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "15px",
  p: 4,
};
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});
function createData(id, items) {
  return {
    id,
    items,
  };
}
function generateRandomString() {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < 4; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
}
export default function ImprestExpenditure() {
  const category = useSelector((state) => state.category.cart).filter(
    (d) => d.category !== "IMPREST"
  );

  const [open, setOpen] = React.useState(false);

  const claims = useSelector((state) => state.claims.claims);
  const [claimsData, setClaimsData] = React.useState(claims);

  const neededData = claimsData.filter(
    (d) =>
      (d.parent_category === "IMPREST" || d.category === "IMPREST") &&
      d.payment_status === "Paid"
  );
  const neededData2 = claimsData.filter(
    (d) => d.category === "IMPREST" || d.utilisation_approval === "pending"
  );

  const groupedData = neededData2.reduce((result, item) => {
    const { imprest_code } = item;

    if (!result[imprest_code]) {
      result[imprest_code] = {
        imprest_code,
        items: [],
      };
    }

    result[imprest_code].items.push({ ...item });

    return result;
  }, {});

  const formattedData = Object.values(groupedData).map((group) => ({
    imprest_code: group.imprest_code,
    items: group.items.filter((item) => item.category !== "IMPREST"),
  }));
  const rows = formattedData.map((data) =>
    createData(data.imprest_code, data.items)
  );

  React.useEffect(() => {
    setClaimsData(claims);
  }, [claims]);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const branch = (
    user.results.branch[0] +
    user.results.branch[1] +
    user.results.branch[2]
  ).toUpperCase();
  const codes = `${branch}-${generateRandomString()}-${claims.length + 1}`;
  let [claim, setClaim] = React.useState({
    employee_name: "",
    department: "",
    category: "",
    date: "",
    description: "",
    amount: "",
    sanctioned_by: "",
    branch: "",
    claim_code: "",
    status: "pending",
    payment_status: "",
    attention_to: "",
    designation: "",
    imprest_code: "",
    parent_category: "IMPREST",
    payee_branch: "",
    imprest_amount: "",
    utilisation_approval: "",
  });
  const [refund, setRefund] = React.useState("");

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeCategory = (event) => {
    setClaim({ ...claim, category: event.target.value });
  };
  const [utilisingId, setUtilisingId] = React.useState("");
  function payApprovedClaim() {
    const data = neededData.filter((d) => d.imprest_code === utilisingId);
    const imprest_data = neededData.filter((d) => d.claim_code === utilisingId);
    const imprest_amount = imprest_data[0]?.amount;
    const amount = data.reduce((acc, d) => acc + d.amount, 0) - imprest_amount;
    if (!claim.category || !claim.amount) {
      toast.error("Please fill in required fields");
      return;
    }
    if (claim.amount * 1 <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }
    if (amount + claim.amount * 1 > imprest_amount) {
      toast.error("Total amount spent can't exceed imprest amount");
      return;
    }

    if (refund && refund * 1 < 0) {
      toast.error("Invalid refund amount");
      return;
    }
    dispatch(createClaim(claim));
    dispatch(
      updateBranchClaim(imprest_data[0]?._id, { imprest_refund: refund })
    );
    setClaim({ ...claim, amount: "", category: "" });
  }
  const ExpensesRow = ({ expenses }) => {
    const [openTab, setOpenTab] = React.useState(false);
    const id = expenses.id;
    const data = neededData.filter((d) => d.claim_code === id);
    const dataAttached = neededData.filter((d) => d.claim_code === utilisingId);

    claim.claim_code = codes;
    claim.employee_name = dataAttached[0]?.employee_name;
    claim.department = dataAttached[0]?.department;
    claim.date = dataAttached[0]?.date;
    claim.description = dataAttached[0]?.description;
    claim.sanctioned_by = dataAttached[0]?.sanctioned_by;
    claim.branch = dataAttached[0]?.branch;
    claim.status = "pending";
    claim.payment_status = dataAttached[0]?.payment_status;
    claim.attention_to = dataAttached[0]?.attention_to;
    claim.designation = dataAttached[0]?.designation;
    claim.imprest_code = dataAttached[0]?.claim_code;
    // claim.parent_category = dataAttached[0]?.parent_category;
    claim.payee_branch = dataAttached[0]?.payee_branch;
    claim.imprest_amount = dataAttached[0]?.amount;
    claim.utilisation_approval = "pending";

    return (
      <>
        <TableRow style={{ backgroundColor: "#e5e7eb" }}>
          <TableCell>
            <IconButton size='small' onClick={() => setOpenTab(!openTab)}>
              {openTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <FolderIcon />
            {expenses.id} - {data[0]?.employee_name}
          </TableCell>
          <TableCell style={{}}>{data[0]?.amount}</TableCell>
          <TableCell>
            <Paper style={{ width: "fit-content" }}>
              <Tooltip title='Utilise this claim'>
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setUtilisingId(expenses.id);
                  }}
                  size='small'>
                  Utilise
                </IconButton>
              </Tooltip>
            </Paper>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
            <Collapse in={openTab} timeout='auto' unmountOnExit>
              <Table stickyHeader size='small' aria-label='a dense table'>
                <TableHead style={{ backgroundColor: "#75CA93 " }}>
                  <TableRow style={{ backgroundColor: "#75CA93 " }}>
                    <StyledTableCell align='left'>
                      <em>#</em>
                    </StyledTableCell>
                    <StyledTableCell width={"200px"} align='left'>
                      CODE
                    </StyledTableCell>
                    <StyledTableCell align='left'>DATE</StyledTableCell>
                    <StyledTableCell align='left'>
                      EMPLOYEE NAME
                    </StyledTableCell>
                    <StyledTableCell align='left'>BRANCH</StyledTableCell>
                    <StyledTableCell align='left'>DEPARTMENT</StyledTableCell>
                    <StyledTableCell align='left'>CATEGORY</StyledTableCell>
                    <StyledTableCell align='left'>DESIGNATION</StyledTableCell>
                    <StyledTableCell align='left'>
                      SANCTIONED BY
                    </StyledTableCell>
                    <StyledTableCell align='left'>AMOUNT</StyledTableCell>
                    <StyledTableCell align='left'>
                      PAYMENT STATUS
                    </StyledTableCell>
                    <StyledTableCell align='left'>STATUS</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expenses.items.map((row, index) => (
                    <StyledTableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}>
                      <StyledTableCell align='left' component='th' scope='row'>
                        <em style={{ fontWeight: "bold" }}>{index + 1}</em>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'
                        component='th'
                        scope='row'>
                        {row.claim_code}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'
                        component='th'
                        scope='row'>
                        {row.date}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'>
                        {row.employee_name}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.branch}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.department}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "250px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.category}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "250px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.designation}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.sanctioned_by}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'>
                        {currencyFormatter.format(row.amount)}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.payment_status}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.status}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };
  const data_ = neededData.filter((d) => d.imprest_code === utilisingId);
  const imprest_data = neededData.filter((d) => d.claim_code === utilisingId);
  const imprest_amount = imprest_data[0]?.amount;
  const amount = data_.reduce((acc, d) => acc + d.amount, 0) - imprest_amount;
  return (
    <div style={{ marginTop: "100px" }}>
      <Helmet title='Utilise Imprest - eClaim' />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Typography>Imprest Amount: {imprest_amount || 0}</Typography>
            <Typography>
              Amount Spent:{amount + claim.amount * 1 || 0}
            </Typography>
            <Typography>
              Refund?:{" "}
              <input
                value={refund}
                onChange={(e) => setRefund(e.target.value)}
                type='number'
                placeholder='refund amount here'
              />
            </Typography>
          </div>
          <em style={{ color: "red" }}>
            {amount + claim.amount * 1 > imprest_amount
              ? "amount spent can't exceed imprest amount"
              : ""}
          </em>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <FormControl variant='standard' sx={{ m: 1, minWidth: 150 }}>
              <InputLabel required id='demo-simple-select-standard-label'>
                Category
              </InputLabel>
              <Select
                labelId='demo-simple-select-standard-label'
                id='demo-simple-select-standard'
                value={claim.category}
                onChange={handleChangeCategory}
                label='Category'>
                <MenuItem value=''>
                  <em>None</em>
                </MenuItem>
                {category.map((data) => (
                  <MenuItem key={data._id} value={data.category}>
                    {data.category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}>
              <Typography>
                Amount<span style={{ color: "#000000" }}> *</span> :
              </Typography>
              <input
                style={{ marginLeft: "5px" }}
                placeholder='enter amount'
                size='small'
                type='number'
                required
                value={claim.amount}
                onChange={(e) => setClaim({ ...claim, amount: e.target.value })}
              />
            </div>
          </div>
          <Divider style={{ backgroundColor: "black" }} />
          <div
            style={{
              padding: "5px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Button onClick={payApprovedClaim} variant='contained'>
              Submit
            </Button>
            <Button onClick={handleClose} style={{ color: "red" }}>
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          margin: "5px",
        }}>
        <TextField
          value={code}
          required
          onChange={(e) => setCode(e.target.value)}
          size='small'
          type='text'
          label='enter claim code to search'
          placeholder='enter claim code'
          InputProps={{
            endAdornment: (
              <IconButton onClick={searchData}>
                <SearchRoundedIcon />
              </IconButton>
            ),
          }}
        />
        <Button onClick={() => setClaimsData(claims)}>Reset</Button>
      </div> */}
      <TableContainer component={Paper}>
        <Table size='small' aria-label='collapsible table'>
          <TableHead
            style={{
              backgroundColor: "#cccccc",
              fontWeight: "bold",
              color: "#fff",
            }}>
            <TableRow>
              <TableCell />
              <TableCell style={{ fontWeight: "bold", color: "#000000" }}>
                Imprest Code-Recipient Name
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "#000000" }}>
                Amount
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  color: "#000000",
                  width: "fit-content",
                }}>
                Action
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((expense, index) => (
              <ExpensesRow key={index} expenses={expense} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
